@if (loading()) {
	<div class="spin-wrapper"><nz-spin nzSimple nzSize="large"></nz-spin></div>
}
@if (!loading() && activity()) {
	<div>
		@if (started()) {
			<div #container class="fade-in"></div>
		}
	</div>
}
